import type { JSX, ReactNode, HTMLAttributes } from 'react';
import { styled } from 'styled-components';
import { TableSectionContext } from './TableSectionContext';

export type TableBodyProps = HTMLAttributes<HTMLTableSectionElement> & {
  children?: ReactNode;
};

const StyledTableBody = styled.tbody`
  width: 100%;
`;

export const TableBody = ({ children, ...props }: TableBodyProps): JSX.Element => {
  return (
    <TableSectionContext.Provider value="body">
      <StyledTableBody {...props}>{children}</StyledTableBody>
    </TableSectionContext.Provider>
  );
};
